import styled from 'styled-components';
import { colors, MediaQuery, zIndexes } from '../../../theme/style-helpers';

export const Overlay = styled.div`
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  z-index: 1;
  position: fixed;
  z-index: ${zIndexes.MODAL};
  background-color: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(2px);
`;

export const Panel = styled.div`
  display: grid;
  grid-gap: 16px;
  grid-auto-rows: min-content auto;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  background-color: ${colors.WHITE};
  z-index: ${zIndexes.MODAL + 1};
  transform: translateX(100%);

  ${MediaQuery.small`
    width: 460px;
  `};
`;

export const PanelHeader = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  height: max-content;
  padding: 24px;
`;

export const PanelBody = styled.div`
  display: grid;
  grid-auto-flow: row;
  grid-auto-rows: max-content;
  row-gap: 32px;
  padding: 0px 20px 20px;
  margin-bottom: ${({ panelBodyBottom }) => (panelBodyBottom ? `${panelBodyBottom}px` : '80px')};
  overflow-y: auto;

  ${MediaQuery.small`
    padding: 0px 48px 20px;
  `};
`;

export const PanelFooter = styled.div`
  position: fixed;
  left: 0;
  bottom: 0;
  display: grid;
  grid-gap: 16px;
  grid-auto-flow: column;
  width: 100%;
  padding: 16px 20px;
  border-top: 1px solid ${colors.COOL_GREY};

  ${MediaQuery.small`
    grid-gap: 20px;
    padding: 16px 48px;
  `};
`;

export const CloseButton = styled.button`
  border: none;
  background-color: transparent;
  cursor: pointer;

  * {
    pointer-events: none;
  }

  object {
    width: 20px;
  };
`;

export const Container = styled.div`
  display: ${({ isOpen }) => (isOpen ? 'flex' : 'none')};

  ${Panel} {
    transition: transform .15s ease-in;
    transform: ${({ isOpen }) => (isOpen ? 'translateX(0)' : 'translateX(100%)')};
  };

  ${Overlay} {
    display: ${({ isOpen }) => (isOpen ? 'flex' : 'none')};
  };
`;
